
import actionType from "./actionTypes";
import axios from "axios";
import { toast, ToastType } from "react-toastify";
import { hideIsLoading, showIsLoading, refreshApiService } from "../common/action";
import URL from "../../assets/config";

export const facilityRegisterService = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.facility.FACILITY_REGISTER,
    data: payload
   };


  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.FACILITY_REGISTER_SUCCESS,
          message: res.data.message
        });
       // toast.success(res.data.message,"You can registration is pending");
    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_REGISTER_FAILURE,
        error: res.data.message
      })
    //  toast.success(res.data.message);
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     dispatch({
       type: actionType.FACILITY_REGISTER_FAILURE,
       error: error
     });
   });
};
 

export const facilitySendOtp = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.facility.FACILITY_REGISTER_OTP,
    data: payload
   };

 
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.FACILITY_SEND_OTP_SUCCESS,
          message: res.data.message
        });
        toast.success(res.data.message);

    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_SEND_OTP_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     dispatch({
       type: actionType.FACILITY_SEND_OTP_FAILURE,
       error: error
     });
   });
};


export const facilityConfirmOtp = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.facility.FACILITY_REGISTER_CONFIRM_OTP,
    data: payload
   };

 
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.FACILITY_CONFIRM_OTP_SUCCESS,
          message: res.data.message
        });
        toast.success(res.data.message);

    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_CONFIRM_OTP_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
    
  }).catch(error => {
     dispatch(hideIsLoading());
     dispatch({
       type: actionType.FACILITY_CONFIRM_OTP_FAILURE,
       error: error
     });
   });
};



export const getPractisionersList = (token, id, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.facility.GET_PRACTITIONERS_LIST + id,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.GET_PRACTITIONERS_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_PRACTITIONERS_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getPractisionersList, id))
   }
     dispatch({
       type: actionType.GET_PRACTITIONERS_FAILURE,
       error: error
     });
   });
};
 

export const addPractitioners = (token,  payload, ) => dispatch => {
  toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.facility.ADD_PRACTITIONERS,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
      data : payload,
 
   };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
           dispatch({
            type: actionType.ADD_PRACTITIONERS_SUCCESS,
            message: res.data.message
          });
         toast.success(res.data.message);
      } else if (res.status === 206) {
        dispatch({
          type: actionType.ADD_PRACTITIONERS_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message);
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(addPractitioners,payload))
     }
       dispatch({
         type: actionType.ADD_PRACTITIONERS_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   

  export const editPractitioner = (token, userId, Payload, ) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'put',
      url: URL.facility.EDIT_PRACTITIONER,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
      data : Payload,
      };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getPractisionersList(token, userId, ));
          dispatch({
            type: actionType.EDIT_PRACTITIONER_SUCCESS,
            message: res.data.message
          });
          toast.success(res.data.message);
      } else if (res.status === 206) {
        dispatch({
          type: actionType.EDIT_PRACTITIONER_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message);
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(editPractitioner, userId, Payload ))
     }
       dispatch({
         type: actionType.EDIT_PRACTITIONER_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   

  export const deletePractitioner = (token, userId, id, ) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'delete',
      url: URL.facility.DELETE_PRACTITIONER + id ,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getPractisionersList(token, userId, ));
          dispatch({
            type: actionType.DELETE_PRACTITIONER_SUCCESS,
            message: res.data.message
          });
          toast.success(res.data.message);
      } else if (res.status === 206) {
 
        dispatch({
          type: actionType.DELETE_PRACTITIONER_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message);
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(deletePractitioner, userId, id ))
     }
       dispatch({
         type: actionType.DELETE_PRACTITIONER_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   



  export const getEmrDetails = (token, id) => dispatch =>{
    toast.dismiss();

    dispatch(showIsLoading());
    const config = {
      method: 'get',
      url: URL.facility.GET_CLOUD_BASE_EMR_VPN + id,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
 
          dispatch({
            type: actionType.GET_CLOUD_BASE_EMR_VPN_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_CLOUD_BASE_EMR_VPN_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getEmrDetails, id ))
     }
       dispatch({
         type: actionType.GET_CLOUD_BASE_EMR_VPN_FAILURE,
         error: error
       });
     });
  };


   export const getRemoteAccessVPN = (token, id) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.facility.GET_REMOTE_ACCESS_VPN + id,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
  
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.GET_REMOTE_ACCESS_VPN_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_REMOTE_ACCESS_VPN_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getRemoteAccessVPN, id ))
     }
       dispatch({
         type: actionType.GET_REMOTE_ACCESS_VPN_FAILURE,
         error: error
       });
     });
  };





  export const saveCloudBaseEMR = (token, payload, id) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
    const config = {
      method: 'post',
      url: URL.facility.SAVE_CLOUD_BASE_EMR,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     } 

    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmrDetails(token, id))
          dispatch(getRemoteAccessVPN(token, id));
          toast.success(res.data.message);
          dispatch({
            type: actionType.SAVE_CLOUD_BASE_EMR_SUCCESS,
            message: res.data.message
          });
      } else if (res.status === 206) {
        toast.success(res.data.message);
        dispatch({
          type: actionType.SAVE_CLOUD_BASE_EMR_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(saveCloudBaseEMR,  payload, id ))
     }
       dispatch({
         type: actionType.SAVE_CLOUD_BASE_EMR_FAILURE,
         error: error
       });
     });
  };


  
  export const saveRemoteVpn = (token, payload,  id) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
    const config = {
      method: 'post',
      url: URL.facility.SAVE_REMOTE_VPN,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     } 

    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmrDetails(token, id))
          dispatch(getRemoteAccessVPN(token, id));
          toast.success(res.data.message);
          dispatch({
            type: actionType.SAVE_REMOTE_VPN_SUCCESS,
            message: res.data.message
          });
      } else if (res.status === 206) {
        toast.success(res.data.message);
        dispatch({
          type: actionType.SAVE_REMOTE_VPN_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(saveRemoteVpn,  payload, id ))
     }
       dispatch({
         type: actionType.SAVE_REMOTE_VPN_FAILURE,
         error: error
       });
     });
  };


  export const emailBaaDoc = (payload,) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
    const config = {
      method: 'post',
      url: URL.facility.EMAIL_BAA_DOC,
      data:payload,
      headers: {
        'content-type': 'multipart/form-data'
    }
     } 

    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          toast.success(res.data.message)
          dispatch({
            type: actionType.EMAIL_BAA_DOC_SUCCESS,
            message: res.data.message
          });

      } else if (res.status === 206) {
        dispatch({
          type: actionType.EMAIL_BAA_DOC_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(emailBaaDoc,  payload  ))
     }
       dispatch({
         type: actionType.EMAIL_BAA_DOC_FAILURE,
         error: error
       });
     });
  };

  export const getFacilityRecordReqList = (token, userId, )=>dispatch=>{
    toast.dismiss();

    const config = {
      method: 'get',
      url: URL.facility.REQUEST_INFO_LIST + userId,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
     axios(config).then((res) => {
      if (res.status === 200) {
        dispatch({
          type: actionType.FACILITY_REQ_LIST_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.FACILITY_REQ_LIST_FAILURE,
          error: res.data.message
        })
      }
      
     }).catch(error => {
      dispatch(hideIsLoading());
      if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getFacilityRecordReqList,  userId  ))
    }
    dispatch({
      type: actionType.FACILITY_REQ_LIST_FAILURE,
      error: error.message
    })
    });
  
  };


  export const verifyStateService = (token, payload, )=>dispatch=>{
    toast.dismiss();

    const config = {
      method: 'post',
      url: URL.facility.VERIFY_SERVICE ,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
     axios(config).then((res) => {
      if (res.status === 200) {
        dispatch({
          type: actionType.VERIFY_SERVICE_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.VERIFY_SERVICE_FAILURE,
          error: res.data.message
        })
      }
      
     }).catch(error => {
      dispatch(hideIsLoading());
      if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(verifyStateService,  payload  ))
    }
    dispatch({
      type: actionType.VERIFY_SERVICE_FAILURE,
      error: error.message
    })
    });
  
  };

  export const FacilitySelectOtherType = (token, facilityId )=>dispatch=>{
    toast.dismiss();

    dispatch(showIsLoading());
     const config = {
      method: 'post',
      data : { facilityId},
      url: URL.facility.FACILITY_SELECT_TYPE ,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  ,
     };
     axios(config).then((res) => {
      dispatch(hideIsLoading());
       if (res.status === 200) {
        
         dispatch({
          type: actionType.FACILITY_SELECT_TYPE_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.FACILITY_SELECT_TYPE_FAILURE,
          error: res.data.message
        })
      }
      
     }).catch(error => {
      dispatch(hideIsLoading());
      if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(FacilitySelectOtherType  ))
    }
    dispatch({
      type: actionType.FACILITY_SELECT_TYPE_FAILURE,
      error: error.message
    })
    });
  
  };

  

 export const  CreateUpdateSelected = (token, Payload )=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
  const config = {
   method: 'post',
   data :Payload,
   url: URL.facility.FACILITY_CREATE_UPDATE_SELECTED ,
   headers: {
     'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
   }  ,
  };
  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(FacilitySelectOtherType(token, Payload.facilityId))
      toast.success(res.data.message);
      dispatch({
       type: actionType.FACILITY_CREATE_UPDATE_SELECTED_SUCCESS,
       payload: res.data,
       message: res.data.message
     });
   } else if (res.status === 206) {
    dispatch(hideIsLoading())
    toast.error(res.data.message);
     dispatch({
       type: actionType.FACILITY_CREATE_UPDATE_SELECTED_FAILURE,
       error: res.data.message
     })
   }
   
  }).catch(error => {
   dispatch(hideIsLoading());
   if(error.response.data.error == "invalid_token"){
    dispatch(refreshApiService( CreateUpdateSelected, Payload  ))
 }
 dispatch({
   type: actionType.FACILITY_CREATE_UPDATE_SELECTED_FAILURE,
   error: error.message
 })
 });

};

export const  approveStatus = (token, id, userId )=>dispatch=>{
  toast.dismiss();

  var formBody = [];
  formBody.push("requestId" + "=" +  id );
  formBody = formBody.join("&");



  dispatch(showIsLoading());
  const config = {
   method: 'post',
   data : formBody,
   url: URL.facility.APPROVE_STATUS ,
   headers: {
    'Content-Type': "application/x-www-form-urlencoded",
    "Authorization": 'bearer  ' + token,
  } ,
  };
  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(getFacilityRecordReqList(token,userId))
      dispatch({
       type: actionType.APPROVE_FACILITY_SUCCESS,
       payload: res.data,
       message: res.data.message
     });
     toast.success(res.data.message)
   } else if (res.status === 206) {
     dispatch({
       type: actionType.APPROVE_FACILITY_FAILURE,
       error: res.data.message
     })
     toast.error(res.data.message)
   }
   
  }).catch(error => {
   dispatch(hideIsLoading());
   if(error.response.data.error == "invalid_token"){
    dispatch(refreshApiService( approveStatus,id ))
 }
 dispatch({
   type: actionType.APPROVE_FACILITY_FAILURE,
   error: error.message
 })
 });

};


export const  declineStatus = (token, id, userId )=>dispatch=>{
  toast.dismiss();

  var formBody = [];
  formBody.push("reqId" + "=" +  id );
  formBody = formBody.join("&");



  dispatch(showIsLoading());
  const config = {
   method: 'post',
   data : formBody,
   url: URL.facility.DECLINE_STATUS ,
   headers: {
    'Content-Type': "application/x-www-form-urlencoded",
    "Authorization": 'bearer  ' + token,
  } ,
  };
  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(getFacilityRecordReqList(token,userId))
      dispatch({
       type: actionType.DECLINE_FACILITY_SUCCESS,
       payload: res.data,
       message: res.data.message
     });
     toast.success(res.data.message)
   } else if (res.status === 206) {
     dispatch({
       type: actionType.DECLINE_FACILITY_FAILURE,
       error: res.data.message
     })
     toast.error(res.data.message)
   }
   
  }).catch(error => {
   dispatch(hideIsLoading());
   if(error.response.data.error == "invalid_token"){
    dispatch(refreshApiService( declineStatus,id ))
 }
 dispatch({
   type: actionType.DECLINE_FACILITY_FAILURE,
   error: error.message
 })
 });

};

 
  export const statusChangeService = () => dispatch => {

    dispatch({
        type:actionType.STATUS_CHANGE_FINAL_REG,
       })
    }

 export const RegisterstatusChange = () => dispatch => {

  dispatch({
      type:actionType.SAVE_REG_DATA_STATUS_CHANGE,
     })
  }




export const saveRegisteredData = Payload => dispatch => {
  dispatch({
    type:actionType.SAVE_REG_DATA,
    payload: Payload
  })
}